import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Row, Col, Nav } from 'react-bootstrap';
import { TabContent } from './TabGroupContent';
export const TabLayout = ({ nav, tabs }) => {
    return (_jsx(_Fragment, { children: _jsx(Row, { children: _jsxs(Col, { children: [_jsx(Nav, Object.assign({ variant: 'tabs', className: 'flex-row' }, { children: nav })), _jsx(TabContent, { tabs: tabs })] }) }) }));
};
